import { Controller } from "@hotwired/stimulus";
import { turboRequest } from "../helpers/api";
let timer = "";
const pollSubmissionTimers = new Map();
const pollSubmissionRequests = new Map();
let pageHideListenerAdded = false;

function handlePollPageHide() {
  for (const [pollId, request] of pollSubmissionRequests) {
    clearTimeout(pollSubmissionTimers.get(pollId));

    fetch(request.action, {
      method: request.method,
      body: request.body,
      credentials: "same-origin",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token":
          document.querySelector('meta[name="csrf-token"]')?.content || "",
        "X-Requested-With": "XMLHttpRequest",
      },
      keepalive: true,
    });

    pollSubmissionTimers.delete(pollId);
    pollSubmissionRequests.delete(pollId);
  }
}

function enqueuePollSubmission(form, selected) {
  const pollId = form.querySelector(
    '[name="user_poll_answer[post_poll_id]"]',
  )?.value;

  if (!pollId) return;

  const body = new FormData(form);

  body.set(
    "user_poll_answer[selected]",
    selected ? "true" : "false",
  );

  pollSubmissionRequests.set(pollId, {
    action: form.action,
    method: form.method || "post",
    body,
  });

  clearTimeout(pollSubmissionTimers.get(pollId));

  const timer = setTimeout(() => {
    submitPollAnswer(pollId);
  }, 1500);

  pollSubmissionTimers.set(pollId, timer);
}

async function submitPollAnswer(pollId) {
  const request = pollSubmissionRequests.get(pollId);

  if (!request) return;

  clearTimeout(pollSubmissionTimers.get(pollId));

  pollSubmissionTimers.delete(pollId);
  pollSubmissionRequests.delete(pollId);

  try {
    const response = await turboRequest(request.action, {
      method: request.method,
      params: request.body,
      turboStream: true,
      renderTurboStream: false,
    });

    if (response) {
      globalThis.Turbo.renderStreamMessage(response);
    }
  } catch (error) {
    console.error("Unable to update poll answer", error);
  }
}

export default class UserController extends Controller {
  static targets = ["confirmButton", "customCheckbox", "timepicker"];

  connect() {
    if (this.hasCustomCheckboxTarget) {
      this.toggleTimepickers();
    }

    if (!pageHideListenerAdded) {
      globalThis.addEventListener("pagehide", handlePollPageHide);
      pageHideListenerAdded = true;
    }
  }

  updatePaymentType(event) {
    event.preventDefault();
    $(event.target).closest("form")[0].requestSubmit();
  }

  toggleButton(e) {
    const selected = e.target.value;
    const button = this.confirmButtonTarget;

    $(".delete-account").removeClass("disabled");

    if (selected === "Delete") {
      $(".delete-account-options").removeClass("d-none");

      button.dataset.confirmationConfirmTextValue = "Yes";
    } else {
      $(".delete-account-options").addClass("d-none");
      $('.delete-account-options input[type="checkbox"]').prop(
        "checked",
        false,
      );

      button.dataset.confirmationConfirmTextValue = "Yes, Disable it!";
    }
  }

  submitData(event) {
    const form = event.target.closest("form");
    if (!form) return;

    const pollId = form.querySelector(
      '[name="user_poll_answer[post_poll_id]"]',
    )?.value;

    if (!pollId) {
      form.requestSubmit();
      return;
    }

    const selectedLabel = event.target.closest("label.question-field") ||
      event.target.closest(".poll-question")?.querySelector("label.question-field");

    if (!selectedLabel) return;

    const selectedOption = selectedLabel.closest(".poll-options");
    const selectedPercentageElement =
      selectedOption?.querySelector(".poll-percentage");

    const wasSelected = selectedLabel.classList.contains("bg-tomato");

    const previousSelectedLabel = form.querySelector(
      ".question-field.bg-tomato",
    );

    const previousSelectedOption =
      previousSelectedLabel?.closest(".poll-options");

    const previousPercentageElement =
      previousSelectedOption?.querySelector(".poll-percentage");

    if (wasSelected) {
      const votes = Number(
        selectedPercentageElement?.dataset.votes || 0,
      );

      if (selectedPercentageElement) {
        selectedPercentageElement.dataset.votes =
          Math.max(0, votes - 1);
      }

      event.currentTarget.checked = false
      selectedLabel.classList.remove("bg-tomato");
      selectedLabel.classList.add("bg-dark-purple");

      this.updatePollPercentages(form);
      this.syncPollCopies(pollId, form);

      enqueuePollSubmission(form, false);
      return;
    }

    if (previousPercentageElement) {
      const previousVotes = Number(
        previousPercentageElement.dataset.votes || 0,
      );

      previousPercentageElement.dataset.votes =
        Math.max(0, previousVotes - 1);
    }

    if (selectedPercentageElement) {
      const selectedVotes = Number(
        selectedPercentageElement.dataset.votes || 0,
      );

      selectedPercentageElement.dataset.votes =
        selectedVotes + 1;
    }

    form.querySelectorAll(".question-field").forEach((label) => {
      label.classList.remove("bg-tomato");
      label.classList.add("bg-dark-purple");
    });

    selectedLabel.classList.remove("bg-dark-purple");
    selectedLabel.classList.add("bg-tomato");

    this.updatePollPercentages(form);
    this.syncPollCopies(pollId, form);

    enqueuePollSubmission(form, true);
  }

  syncPollCopies(pollId, sourceForm) {
    const sourceOptions = Array.from(
      sourceForm.querySelectorAll('.poll-options')
    );

    document.querySelectorAll(
      'form.post-poll-options [name="user_poll_answer[post_poll_id]"]'
    ).forEach((pollIdInput) => {
      if (pollIdInput.value !== pollId) return;

      const targetForm = pollIdInput.closest('form');
      if (!targetForm || targetForm === sourceForm) return;

      sourceOptions.forEach((sourceOption) => {
        const sourceInput = sourceOption.querySelector(
          '[name="user_poll_answer[poll_option_id]"]'
        );
        if (!sourceInput) return;

        const targetInput = Array.from(targetForm.querySelectorAll(
          '[name="user_poll_answer[poll_option_id]"]'
        )).find(input => input.value === sourceInput.value);
        const targetOption = targetInput?.closest('.poll-options');
        if (!targetInput || !targetOption) return;

        targetInput.checked = sourceInput.checked;

        const sourceLabel = sourceOption.querySelector('.question-field');
        const targetLabel = targetOption.querySelector('.question-field');
        targetLabel?.classList.toggle('bg-tomato', sourceLabel?.classList.contains('bg-tomato'));
        targetLabel?.classList.toggle('bg-dark-purple', sourceLabel?.classList.contains('bg-dark-purple'));

        const sourcePercentage = sourceOption.querySelector('.poll-percentage');
        const targetPercentage = targetOption.querySelector('.poll-percentage');
        if (sourcePercentage && targetPercentage) {
          targetPercentage.textContent = sourcePercentage.textContent;
          targetPercentage.dataset.votes = sourcePercentage.dataset.votes;
          targetPercentage.dataset.totalVotes = sourcePercentage.dataset.totalVotes;
        }

        const sourceProgress = sourceOption.querySelector('.poll-question > .position-absolute');
        const targetProgress = targetOption.querySelector('.poll-question > .position-absolute');
        if (sourceProgress && targetProgress) {
          targetProgress.style.width = sourceProgress.style.width;
        }
      });
    });
  }


  updatePollPercentages(form) {
    const options = [
      ...form.querySelectorAll(".poll-options"),
    ];

    const totalVotes = options.reduce((total, option) => {
      const percentageElement =
        option.querySelector(".poll-percentage");

      return total + Number(
        percentageElement?.dataset.votes || 0,
      );
    }, 0);

    options.forEach((option) => {
      const percentageElement =
        option.querySelector(".poll-percentage");

      const progress =
        option.querySelector(
          ".poll-question > .position-absolute",
        );

      const votes = Number(
        percentageElement?.dataset.votes || 0,
      );

      const percentage = totalVotes > 0
        ? Math.round((votes / totalVotes) * 100)
        : 0;

      if (percentageElement) {
        percentageElement.textContent = `${percentage}%`;
      }

      if (progress) {
        progress.style.width = `${percentage}%`;
      }
    });
    const pollId = form.querySelector(
      '[name="user_poll_answer[post_poll_id]"]'
    )?.value;

    if (pollId) {
      document.querySelectorAll(`.poll_votes_count_${pollId}`).forEach((count) => {
        count.textContent = `${totalVotes} Votes - `;
      });
    }
  }

  addNotification(event) {
    $(event.target).closest("form")[0].requestSubmit();
  }

  async removeData(e) {
    const $container = $(this.element)
      .closest(".analytics-page")
      .find(".interest-value");
    let interestId = $(this.element).prev("span").data("value");
    this.element.closest(".remove-interest").remove();
    $("select option[value=" + interestId + "]").prop("disabled", false);
    if ($container.children().length === 0) {
      $container.removeClass("d-flex").addClass("d-none");
    }
    let array_name = [];
    $(".interest-name-value").each(function (index, element) {
      array_name.push($(element).attr("data-value"));
    });

    const turboRequest = await this.loadTurboRequest();
    await turboRequest("/connects?interest_name=" + array_name, {
      method: "get",
      turboStream: true,
    });
  }

  userSearch(e) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      e.preventDefault();
      let form = $(e.target).closest("form");
      form[0].requestSubmit();
    }, 500);
  }

  closeMessageSearch(e) {
    const form = e.currentTarget.closest(".message_search_box");
    form.querySelector(".message-search").value = "";

    const url = new URL(globalThis.location.href);
    url.searchParams.delete("request");
    url.searchParams.delete("message");

    Turbo.visit(url.toString(), {
      frame: "chat-area",
    });
  }

  showMoreAccounts(e) {
    const showMoreButton = $(e.currentTarget);
    const hiddenElements = showMoreButton
      .closest(".card-container")
      .find(".hiddenAccount");
    const hiddenElements1 = showMoreButton
      .closest(".bank-account-container")
      .find(".hiddenAccount");
    hiddenElements.removeClass("d-none");
    hiddenElements1.removeClass("d-none");
    showMoreButton.hide();
  }

  changeValue(e) {
    const value = Number.parseInt(e.target.value, 10);
    const scale =
      Number.parseInt(e.target.dataset.min) +
      value / Number.parseInt(e.target.dataset.divide || 1);
    document.documentElement.style.setProperty(
      e.target.dataset.property,
      scale,
    );

    const sliderEl = e.target;
    const isTextSize = sliderEl.classList.contains("text-size-slider");
    let tempSliderValue = Number.parseInt(sliderEl.value);
    if (isTextSize) {
      tempSliderValue = Math.floor(tempSliderValue / 2) * 2;
    }
    sliderEl.value = tempSliderValue;
    const progress = (tempSliderValue / sliderEl.max) * 100;
    sliderEl.style.background = `linear-gradient(to right, #E85BF4 ${progress}%, #1EC92F ${progress}%)`;
    this.updateSetting(e);
  }

  togglePrivacySafety(e) {
    e.preventDefault();
    const scheduleManuallyCheckbox = $(".schedule_manually_check_box");
    const privacySafetyDiv = $(".privacy-safety");
    const riseToSetCheckbox = $(".sunset_check_box");
    const customCheckbox = $(".custom_select");
    const turnOnOffDiv = $(".turn-on-off");
    if (scheduleManuallyCheckbox.prop("checked")) {
      privacySafetyDiv.removeClass("d-none");
      if (riseToSetCheckbox.prop("checked")) {
        turnOnOffDiv.removeClass("d-none");
      } else {
        turnOnOffDiv.addClass("d-none");
        customCheckbox.prop("checked", false);
      }
    } else {
      privacySafetyDiv.addClass("d-none");
      turnOnOffDiv.addClass("d-none");
      customCheckbox.prop("checked", false);
    }
    this.updateSetting(e);
  }

  toggleCustom(e) {
    e.preventDefault();
    const isCustom = $(".custom_select");
    const isRise = $(".sunset_check_box");
    const privacySafetyDiv = $(".turn-on-off");
    const form = $(e.target).closest("form");
    if ($(e.target).hasClass("custom_select")) {
      isRise.prop("checked", false);
      isCustom.prop("checked", true);
      privacySafetyDiv.removeClass("d-none");
    }
    if ($(e.target).hasClass("sunset_check_box")) {
      isRise.prop("checked", true);
      isCustom.prop("checked", false);
      privacySafetyDiv.addClass("d-none");
    }
    this.toggleTimepickers();
    form[0].requestSubmit();
  }

  toggleTimepickers() {
    const enabled = this.customCheckboxTarget.checked;

    this.timepickerTargets.forEach((input) => {
      if (enabled) {
        $(input).rules("add", {
          required: true,
        });

        if (input.dataset.ruleGreaterThan) {
          $(input).rules("add", {
            greaterThan: input.dataset.ruleGreaterThan,
          });
        }
      } else {
        $(input).rules("remove", "required greaterThan");
      }
    });
  }

  async updateSetting(event) {
    const input = event.target;
    const form = input.form;
    const token = document.querySelector('meta[name="csrf-token"]').content;

    const formData = new FormData();
    if (input.type === "checkbox") {
      formData.append(input.name, input.checked ? "1" : "0");
    } else {
      formData.append(input.name, input.value);
    }

    const turboRequest = await this.loadTurboRequest();

    await turboRequest(form.action, {
      method: "PUT",
      params: formData,
      turboStream: true,
    });
  }

  async addRemoveTopics(e) {
    let id = $(this.element).attr("data-value");
    let type = $(this.element).attr("data-type");

    const turboRequest = await this.loadTurboRequest();
    await turboRequest("/topics/" + id + "/add_remove_topics?type=" + type, {
      method: "PUT",
      turboStream: true,
    });
  }

  showMoreTopics(e) {
    Turbo.visit("/topics/?type=show_more");
  }

  interestChanged(event) {
    const select = event.target;
    const image = select.dataset.image;

    const $container = $(select)
      .closest(".analytics-page")
      .find(".interest-value");

    $container.empty();

    const values = $(select).val() || [];

    values.forEach((id) => {
      const name = $(select).find(`option[value="${id}"]`).text();

      const $el = $(`
        <div class="remove-interest position-relative d-flex align-items-center justify-content-center px-5 py-1">
          <img class="img img-fluid position-absolute" src="${image}">
          <span
            class="text-white-paint text-black interest-name-value text-center d-inline-block p-font-bold fs-16 position-relative"
            data-value="${id}">
            ${name}
          </span>
          <button
            type="button"
            class="position-relative btn p-0 fs-20 fw-bold scale-hover"
            data-id="${id}">
            <i class="ri-close-fill"></i>
          </button>
        </div>
      `);

      $el.find("button").on("click", (e) => this.removeInterest(e));

      $container.append($el);
    });

    if (values.length) {
      $container.removeClass("d-none").addClass("d-flex");
    } else {
      $container.addClass("d-none").removeClass("d-flex");
    }
  }

  removeInterest(event) {
    const id = event.currentTarget.dataset.id;
    const select = this.element.querySelector(
      '[data-action~="change->user#interestChanged"]',
    );
    const $container = $(this.element)
      .closest(".analytics-page")
      .find(".interest-value");

    $container
      .find(`.interest-name-value[data-value="${id}"]`)
      .closest(".remove-interest")
      .remove();

    let values = $(select).val() || [];
    values = values.filter((value) => value !== id);

    $(select).val(values).trigger("change");
    this.fetchInterestData(select);
  }

  fetchInterestData(select) {
    $(".select2-selection__choice").remove();
    $(".select2-search__field")
      .attr("placeholder", "Select Interest")
      .removeAttr("style");
    select.closest("form").requestSubmit();
  }

  async loadTurboRequest() {
    const turboRequest = (await import("../helpers/api")).turboRequest;
    return turboRequest;
  }

  handlePageHide() {
    for (const [pollId, request] of pollSubmissionRequests) {
      clearTimeout(pollSubmissionTimers.get(pollId));

      request.body.set(
        "user_poll_answer[selected]",
        request.selected ? "true" : "false",
      );

      fetch(request.action, {
        method: "POST",
        body: request.body,
        credentials: "same-origin",
        keepalive: true,
      });

      pollSubmissionTimers.delete(pollId);
      pollSubmissionRequests.delete(pollId);
    }
  }

  disconnect() {
    globalThis.removeEventListener("pagehide", this.handlePageHide)
  }
}
